<div class="container-fuid w-100 sub-header d-flex align-items-center">
    <div class="w-100 ms-2 ms-sm-2 ms-md-4 ms-lg-5 ms-xl-5 ms-xxl-5 me-2 me-sm-2 me-md-4 me-lg-5 me-xl-5 me-xxl-5">
        <app-new-request-picker class="d-none d-lg-block float-start"></app-new-request-picker>
    </div>
</div>